module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Mat Tombers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Part1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINNING")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("1. Taxation Without Representation Is Tyranny")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2"
    }
  }, [_vm._v("2. The Mayhew Dynasty")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Stamp Act\t")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Circular Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Vineyarders")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Whaling")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Tea Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Nye on Naushon")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Vineyard Defense")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The "), _c('i', [_vm._v("Harriot")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Privateering")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. On Nathan Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. On Sharper Michael")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Liberty Pole")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Grey’s Raid")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The "), _c('i', [_vm._v("General Arnold")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. The Battle of Falmouth")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The "), _c('i', [_vm._v("Bonhomme Richard")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. On Nathan Daggett")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. On Beriah Norton")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. On Joseph Thaxter")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0